type PaymentProductReference = { name?: string | null } | string | null | undefined;

export interface IPayment {
    billingTransactionId?: string;
    sourceId?: string;
    sourceType?: string | null;
    orderId: number;
    amount: number;
    amountCaptured: number;
    amountRefunded: number;
    paymentStatus: string;
    paymentStatusCode: number;
    currency: string;
    productType?: string | null;
    productId?: string | null;
    productName?: string | null;
    courseTitle: string;
    courseId: string;
    digitalProductName?: string | null;
    subscriptionProductName?: string | null;
    digitalProduct?: PaymentProductReference;
    subscriptionProduct?: PaymentProductReference;
    userName: string;    

    authorizationCode: string;    
    captured: boolean;    
    paid: boolean;    

    orderStatus: string;    
    paymentMethod: string;    
    last4: string;    

    expMonth: number;
    expYear: number;

    createdAt: Date;
}

export function getPaymentProductName(payment: IPayment | null | undefined): string {
    if (!payment) {
        return '';
    }

    const courseName = normalizeName(payment.courseTitle);
    const productName = normalizeName(payment.productName);
    const digitalProductName = resolveProductName(payment.digitalProduct, payment.digitalProductName);
    const subscriptionProductName = resolveProductName(payment.subscriptionProduct, payment.subscriptionProductName);
    const legacyCourseName = readLooseString(payment, ['CourseTitle', 'courseName', 'CourseName']);
    const legacyProductName = readLooseString(payment, ['ProductName', 'product_name', 'Product']);
    const legacyDigitalProductName = readLooseString(payment, ['DigitalProductName', 'digitalProduct']);
    const legacySubscriptionProductName = readLooseString(payment, ['SubscriptionProductName', 'subscriptionProduct']);

    return (
        courseName ||
        productName ||
        digitalProductName ||
        subscriptionProductName ||
        legacyCourseName ||
        legacyProductName ||
        legacyDigitalProductName ||
        legacySubscriptionProductName
    );
}

function resolveProductName(product: PaymentProductReference, fallbackName?: string | null): string {
    if (typeof product === 'string') {
        return normalizeName(product);
    }

    if (product && typeof product === 'object') {
        return normalizeName(product.name);
    }

    return normalizeName(fallbackName);
}

function normalizeName(value: string | null | undefined): string {
    return (value ?? '').trim();
}

function readLooseString(source: unknown, keys: string[]): string {
    if (!source || typeof source !== 'object') {
        return '';
    }

    const record = source as Record<string, unknown>;
    for (const key of keys) {
        const value = record[key];
        if (typeof value === 'string') {
            const normalized = normalizeName(value);
            if (normalized) {
                return normalized;
            }
        }

        if (value && typeof value === 'object' && 'name' in (value as Record<string, unknown>)) {
            const nestedName = (value as Record<string, unknown>)['name'];
            if (typeof nestedName === 'string') {
                const normalized = normalizeName(nestedName);
                if (normalized) {
                    return normalized;
                }
            }
        }
    }

    return '';
}
